/**
 * Payment methods shared across the app.
 * Used by JobPipeline "Record Payment" modal and InvoiceDetail display.
 */

export const PAYMENT_METHODS = [
  { value: 'zelle',    label: 'Zelle',         icon: '⚡' },
  { value: 'check',    label: 'Check',         icon: '🧾' },
  { value: 'venmo',    label: 'Venmo',         icon: '💸' },
  { value: 'cash',     label: 'Cash',          icon: '💵' },
  { value: 'transfer', label: 'Bank Transfer', icon: '🏦' },
  { value: 'other',    label: 'Other',         icon: '•'  },
];

export const DEFAULT_PAYMENT_METHOD = 'zelle';

export function getPaymentMethod(value) {
  return PAYMENT_METHODS.find((m) => m.value === value) || null;
}

export function getPaymentMethodLabel(value) {
  const m = getPaymentMethod(value);
  return m ? m.label : '';
}

/** Contextual placeholder for the note field, based on selected method. */
export function notePlaceholder(method) {
  switch (method) {
    case 'check':    return 'Check # (optional)';
    case 'zelle':    return 'Confirmation # (optional)';
    case 'venmo':    return 'Venmo handle / note (optional)';
    case 'transfer': return 'Reference # (optional)';
    case 'cash':     return 'Note (optional)';
    default:         return 'Note (optional)';
  }
}
